import { toast } from 'react-toastify';
import { Button } from '@accure/ui';

import {
  Dialog,
  DialogActions,
  DialogDescription,
  type DialogProps,
  DialogTitle,
} from '@/components/ui/dialog';
import { NotifyAccure } from '@/task-manager/api/mutations/notify-accure';
import type { TaskDetails } from '@/task-manager/entities/task-details';

export type NotifyAccureDialogProps = {
  task: TaskDetails;
} & Omit<DialogProps, 'children'>;

export function NotifyAccureDialog({
  task,
  onClose,
  ...props
}: NotifyAccureDialogProps) {
  const notifyAccure = NotifyAccure.useMutation();

  async function handleSubmit() {
    await toast.promise(notifyAccure.mutateAsync(task), {
      pending: 'Contacting ACCURE, please wait...',
      error: 'An unexpected error happened. Please try again.',
      success:
        'We have been notified, We will come back to you as soon as possible.',
    });
    onClose(false);
  }

  return (
    <Dialog onClose={onClose} {...props}>
      <DialogTitle>Notify ACCURE</DialogTitle>
      <DialogDescription>
        Notify us about this task. If you have a question or need further
        information, please add it in the comments section of the task.
      </DialogDescription>
      <DialogActions>
        <Button variant="ghost" onClick={() => onClose(true)}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={notifyAccure.isLoading}>
          Send Notification
        </Button>
      </DialogActions>
    </Dialog>
  );
}
